module.exports = __webpack_public_path__ + "img/ic_32_sport_handball-active.e63b7f26.svg";